import React, { FunctionComponent } from 'react'
import { Icon } from './builders/icon-builder'
import { Link } from 'gatsby'
import { t } from 'ttag'
import { getHrefLang, getLocalizedUrl } from '../utils/localeURL'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import GreenCart from './animations/green-cart'
import GreenSliders from './animations/green-sliders'
import GreenSystem from './animations/green-system'
import GreenWeb from './animations/green-web'

interface TopmImageGreenProps {
  title: string
  text?: string
  icon?: string
  animationStyle?: string
  onLoad?: () => void | undefined,
  links?: {
    main: string;
    contact: string;
  }
}

export default function TopImageGreen(props: TopmImageGreenProps) {
  const { title, text, icon, animationStyle, onLoad, links } = props

  const selectAnimation = () => {
    console.log(animationStyle)

    if (animationStyle == "anim1") {
      return (
        <GreenCart onLoad={onLoad ? () => onLoad() : undefined }/>
      )
    } else if (animationStyle == "anim2") {
      return (
        <GreenSliders onLoad={onLoad ? () => onLoad() : undefined }/>
      )
    } else if (animationStyle == "anim3") {
      return (
        <GreenSystem onLoad={onLoad ? () => onLoad() : undefined }/>
      )
    } else if (animationStyle == "anim4") {
      return (
        <GreenWeb onLoad={onLoad ? () => onLoad() : undefined }/>
      )
    } else {
      return (
        <GreenCart onLoad={onLoad ? () => onLoad() : undefined }/>
      )
    }    
  }

  return (
    <div className="top-image theme-green">
      {
        selectAnimation()
      }
      <div className="content-wrap">
        <div className="pux-container">
          <div className="content">
            {icon ? <Icon id={icon} color="#25d49f" /> : null}
            <h1>{title}</h1>
            {text ? (
              <div className="perex" dangerouslySetInnerHTML={{ __html: text?.replace(/font-size: 1rem;/g, ``) }}></div>
            ) : null}
            {!icon ? (
              <div>
                <AnchorLink className="btn btn-primary btn-big" to={links?.main || "/"}>
                  {t`PuxDesign.Division.AllServices`}
                </AnchorLink>
                <AnchorLink className="btn btn-default btn-big" to={links?.contact || "/"}>
                  {t`PuxDesign.Division.ContactUs`}
                </AnchorLink>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
